// Vendor JS
import Debug from 'debug';

// Custom JS
import CommentReplyNotification from './comment-subscribe';
import CommentAdmin from './comment-admin';
import CommentActions from './comment-actions';

/* eslint-disable no-new */ // Allow using the new keyword while not assigning the class to a variable

class Comments {
	constructor() {
		try {
			this.init();
		} catch (err) {
			Debug(`cig:error:sage:class:CommentActions`)(`constructor Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}

	init = () => {
		try {
			Debug(`cig:info:sage:class:Comments`)(`init start`);

			CommentReplyNotification.init();
			CommentAdmin.init();
			CommentActions.init();

		} catch (err) {
			Debug(`cig:info:sage:class:Comments`)(`init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
}

export default Comments;
